import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { IChargeNumberManagement } from '../IChargeNumberManagement';
import * as ChargeNumberManagementActions from './charge-number-management.actions';

export const chargeNumberManagementsFeatureKey = 'chargeNumberManagements';

export interface State extends EntityState<IChargeNumberManagement> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IChargeNumberManagement> =
    createEntityAdapter<IChargeNumberManagement>({
        selectId: (model: IChargeNumberManagement) => model.CNListID
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const chargeNumberManagementReducer = createReducer(
    initialState,
    on(
        ChargeNumberManagementActions.addChargeNumberManagement,
        (state, action) => adapter.addOne(action.chargeNumberManagement, state)
    ),
    on(
        ChargeNumberManagementActions.upsertChargeNumberManagement,
        (state, action) =>
            adapter.upsertOne(action.chargeNumberManagement, state)
    ),
    on(
        ChargeNumberManagementActions.addChargeNumberManagements,
        (state, action) =>
            adapter.addMany(action.chargeNumberManagements, state)
    ),
    on(
        ChargeNumberManagementActions.upsertChargeNumberManagements,
        (state, action) =>
            adapter.upsertMany(action.chargeNumberManagements, state)
    ),
    on(
        ChargeNumberManagementActions.updateChargeNumberManagement,
        (state, action) =>
            adapter.updateOne(action.chargeNumberManagement, state)
    ),
    on(
        ChargeNumberManagementActions.updateChargeNumberManagements,
        (state, action) =>
            adapter.updateMany(action.chargeNumberManagements, state)
    ),
    on(
        ChargeNumberManagementActions.deleteChargeNumberManagement,
        (state, action) => adapter.removeOne(action.id, state)
    ),
    on(
        ChargeNumberManagementActions.deleteChargeNumberManagements,
        (state, action) => adapter.removeMany(action.ids, state)
    ),
    on(
        ChargeNumberManagementActions.loadChargeNumberManagements,
        (state, action) => adapter.setAll(action.chargeNumberManagements, state)
    ),
    on(ChargeNumberManagementActions.clearChargeNumberManagements, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return chargeNumberManagementReducer(state, action);
}

export const selectChargeNumberMgmtState = createFeatureSelector<State>(
    chargeNumberManagementsFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectChargeNumberMgmtState);
